// @flow
import React, { Fragment } from 'react';
import { MdEdit, MdClose } from 'react-icons/lib/md';

import User from '../../../User';
import SingleTypeSearch from '../../../SingleTypeSearch';
import OmnisearchLoadingResults from '../../../OmnisearchLoadingResults';
// import Loader from '../../../Loader';

import styles from './userCell.css';


export type UserCellPropTypes = {
  pictureURL?: string,
  firstName: string,
  lastName?: string,
  userRole?: string,
  original: Object,
  searchResultType?: string,
  editable?: boolean,
  isLoading?: boolean,
  placeholder?: string,
  onChange?: (Object, Object) => mixed,
};

type UserCellStateTypes = {
  isEditing?: boolean,
};


class UserCell extends React.Component<UserCellPropTypes, UserCellStateTypes> {
  constructor(props: UserCellPropTypes) {
    super(props);

    this.state = {
      isEditing: false,
    };
  }

  _search: ?SingleTypeSearch;

  _onClick() {
    this.setState(
      { isEditing: true },
      () => {
        if (this._search) {
          const input = this._search.getInput();
          input.select();
          input.focus();
        }
      },
    );
  }

  _onBlur() {
    setTimeout(() => {
      this.setState({
        isEditing: false,
      });
    }, 200);
  }

  _onChange(value: Object) {
    const { original, onChange } = this.props;
    if (onChange) {
      onChange(original, value);
    }

    this.setState({
      isEditing: false,
    });
  }

  render() {
    const {
      editable = false,
      isLoading = false,
      searchResultType,
      placeholder = '',
      pictureURL = null,
      firstName = "N/A",
      lastName = "N/A"
    } = this.props;
    const { isEditing } = this.state;

    if (isLoading) {
      return (
        <div className={styles.user}>
          {/* <Loader tint="mediumGray" size="small" /> */}
          <OmnisearchLoadingResults size="small" clearPaddings />
        </div>
      );
    }

    if (editable) {
      return (
        <div className={styles.user}>
          {
            isEditing ? (
              <SingleTypeSearch
                searchResultType={searchResultType}
                placeholder={placeholder}
                onChange={this._onChange.bind(this)}
                ref={
                  (node) => {
                    if (node) {
                      this._search = node.getWrappedInstance();
                      const input = this._search.getInput();
                      input.onblur = this._onBlur.bind(this);
                    } else {
                      this._search = null;
                    }
                  }
                }
                inputProps={{ clearMargins: true, size: 'small' }}
              />
            ) : (
              <div className={styles.editing}>
                <div className={styles.pictureContainer}>
                  {
                    pictureURL != null ? (
                      <img src={pictureURL} />
                    ) : (
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTez7mpG_Lfb01PnEMjHa4gYPOx7iNTab4KKVnVCdNSGpa1O2RJ" alt="" />
                    )
                  }
                  
                </div>
                <div className={styles.name}>
                  {`${firstName} ${lastName}`}
                </div>

                <span className={styles.edit}>
                  <MdClose size={20} onClick={this._onClick.bind(this)} />
                </span>
              </div>
            )
          }
        </div>
      );
    }

    return (
      <div className={styles.user}>
        <User
          size="small"
          {...this.props}
        />
      </div>
    );
  }
}

export default UserCell;



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Cells/User/index.jsx